import { render } from "./App.vue?vue&type=template&id=b8ec0bae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b8ec0bae&lang=scss"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__